var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"monitoramento"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{attrs:{"headerText":"Monitoramento das Aulas Práticas"}},[_vm._v("\n                teste\n            ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }